import { createFileRoute } from "@tanstack/react-router";
import { SystemPage } from "@/features/admin/system-page";
import { ensureSuperAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/system")({
	beforeLoad: async () => {
		await ensureSuperAdminAccess();
	},
	component: SystemPage,
});
